import { useCallback } from 'react';
import { config } from '@shared/config';

/**
 * Returns a function that triggers a browser download for a given artifact ID.
 * Uses the native fetch + blob approach to handle binary downloads.
 */
export function useDownloadArtifact() {
  const download = useCallback(async (artifactId: string) => {
    const baseUrl = config.apiBaseUrl;
    const response = await fetch(`${baseUrl}/artifacts/${artifactId}:download`);
    if (!response.ok) throw new Error(`Download failed: ${response.statusText}`);

    const blob = await response.blob();
    const disposition = response.headers.get('Content-Disposition');
    const filenameMatch = disposition?.match(/filename="(.+)"/);
    const filename = filenameMatch?.[1] ?? `artifact-${artifactId}.zip`;

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, []);

  return download;
}
